// Mock data for Portland Startup Map
// Portland coordinates roughly: 45.5152° N, -122.6784° W

export const STAGES = [
  { id: 'pre-seed', label: 'Pre-seed' },
  { id: 'seed', label: 'Seed' },
  { id: 'series-a', label: 'Series A' },
  { id: 'series-b', label: 'Series B' },
  { id: 'series-c', label: 'Series C+' },
  { id: 'growth', label: 'Growth' },
  { id: 'public', label: 'Public' },
  { id: 'acquired', label: 'Acquired' },
];

export const SECTORS = [
  'AI',
  'B2B SaaS',
  'Fintech',
  'Healthtech',
  'Climate',
  'Devtools',
  'Web Infrastructure',
  'Marketing',
  'Security',
  'Edtech',
  'Proptech',
  'Travel',
  'Commerce',
  'Mobility',
  'Analytics',
  'Gaming',
  'Biotech',
  'Agtech',
  'Aerospace',
  'Hardware',
  'Robotics',
  'Consumer',
  'Food & Bev',
];

// Color palettes for fallback logo backgrounds
const COLORS = [
  '#0F172A', '#1E3A8A', '#7C3AED', '#DB2777', '#DC2626',
  '#EA580C', '#16A34A', '#0D9488', '#0891B2', '#4338CA',
  '#9333EA', '#0EA5E9', '#65A30D', '#BE123C', '#475569',
];

export const STARTUPS = [
  {
    id: 1,
    name: 'Puppet',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Devtools',
    description: 'Infrastructure automation and configuration management platform',
    address: '308 SW 2nd Ave, Portland, OR 97204',
    neighborhood: 'Old Town',
    lat: 45.5219,
    lng: -122.6738,
    color: '#FFAE1A',
    yc: false,
    events: false,
    website: 'puppet.com',
    founded: 2005,
  },
  {
    id: 2,
    name: 'Vacasa',
    badge: 'IPO',
    stage: 'public',
    sector: 'Travel',
    description: 'Full-service vacation rental management company',
    address: '850 NW 13th Ave, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5298,
    lng: -122.6852,
    color: '#E84E1B',
    yc: false,
    events: true,
    website: 'vacasa.com',
    founded: 2009,
  },
  {
    id: 3,
    name: 'Jama Software',
    badge: 'Growth',
    stage: 'growth',
    sector: 'B2B SaaS',
    description: 'Requirements management for complex product development',
    address: '135 SW Taylor St, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5189,
    lng: -122.6766,
    color: '#0066FF',
    yc: false,
    events: false,
    website: 'jamasoftware.com',
    founded: 2007,
  },
  {
    id: 4,
    name: 'CrowdStreet',
    badge: 'Series C',
    stage: 'series-c',
    sector: 'Proptech',
    description: 'Online commercial real estate investment marketplace',
    address: '98 SW Yamhill St, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5193,
    lng: -122.6735,
    color: '#0E4E8C',
    yc: false,
    events: true,
    website: 'crowdstreet.com',
    founded: 2013,
  },
  {
    id: 5,
    name: 'Airship',
    badge: 'Growth',
    stage: 'growth',
    sector: 'Marketing',
    description: 'Customer engagement platform for mobile-first brands',
    address: '1225 W Burnside St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5230,
    lng: -122.6855,
    color: '#FF5A00',
    yc: false,
    events: false,
    website: 'airship.com',
    founded: 2009,
  },
  {
    id: 6,
    name: 'Cloudability',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'B2B SaaS',
    description: 'Cloud cost management and FinOps platform (acquired by Apptio)',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5217,
    lng: -122.6612,
    color: '#7B1FA2',
    yc: false,
    events: false,
    website: 'cloudability.com',
    founded: 2011,
  },
  {
    id: 7,
    name: 'Lytics',
    badge: 'Series C',
    stage: 'series-c',
    sector: 'Marketing',
    description: 'Customer data platform powered by machine learning',
    address: '434 NW 6th Ave, Portland, OR 97209',
    neighborhood: 'Old Town',
    lat: 45.5258,
    lng: -122.6753,
    color: '#22C55E',
    yc: false,
    events: true,
    website: 'lytics.com',
    founded: 2012,
  },
  {
    id: 8,
    name: 'Opal',
    badge: 'Series B',
    stage: 'series-b',
    sector: 'B2B SaaS',
    description: 'Marketing planning and content calendar platform',
    address: '1410 SW Morrison St, Portland, OR 97205',
    neighborhood: 'Downtown',
    lat: 45.5215,
    lng: -122.6875,
    color: '#111827',
    yc: false,
    events: false,
    website: 'workwithopal.com',
    founded: 2011,
  },
  {
    id: 9,
    name: 'Treehouse',
    badge: 'Series B',
    stage: 'series-b',
    sector: 'Edtech',
    description: 'Online technology education platform',
    address: '212 SE 6th Ave, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5202,
    lng: -122.6592,
    color: '#5FCF80',
    yc: false,
    events: false,
    website: 'teamtreehouse.com',
    founded: 2010,
  },
  {
    id: 10,
    name: 'Tripwire',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Security',
    description: 'Cybersecurity and compliance solutions',
    address: '101 SW Main St, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5176,
    lng: -122.6735,
    color: '#DC2626',
    yc: false,
    events: false,
    website: 'tripwire.com',
    founded: 1997,
  },
  {
    id: 11,
    name: 'Act-On',
    badge: 'Growth',
    stage: 'growth',
    sector: 'Marketing',
    description: 'Marketing automation platform for the modern marketer',
    address: '121 SW Morrison St, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5184,
    lng: -122.6754,
    color: '#3B82F6',
    yc: false,
    events: true,
    website: 'act-on.com',
    founded: 2008,
  },
  {
    id: 12,
    name: 'Webtrends',
    badge: 'Growth',
    stage: 'growth',
    sector: 'Analytics',
    description: 'Digital marketing analytics and optimization',
    address: '851 SW 6th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5169,
    lng: -122.6790,
    color: '#0EA5E9',
    yc: false,
    events: false,
    website: 'webtrends.com',
    founded: 1993,
  },
  {
    id: 13,
    name: 'New Relic',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Devtools',
    description: 'Observability platform for engineers (Portland office)',
    address: '111 SW 5th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5197,
    lng: -122.6772,
    color: '#008C99',
    yc: false,
    events: true,
    website: 'newrelic.com',
    founded: 2008,
  },
  {
    id: 14,
    name: 'Smarsh',
    badge: 'Growth',
    stage: 'growth',
    sector: 'B2B SaaS',
    description: 'Communications compliance, archiving and intelligence',
    address: '851 SW 6th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5164,
    lng: -122.6795,
    color: '#001E3C',
    yc: false,
    events: false,
    website: 'smarsh.com',
    founded: 2001,
  },
  {
    id: 15,
    name: 'Galois',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'Security',
    description: 'Formal methods research for trustworthy software',
    address: '421 SW 6th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5178,
    lng: -122.6786,
    color: '#7C3AED',
    yc: false,
    events: false,
    website: 'galois.com',
    founded: 1999,
  },
  {
    id: 16,
    name: 'Polyverse',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'Security',
    description: 'Zero-day attack prevention through moving target defense',
    address: '1455 NW Irving St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5277,
    lng: -122.6889,
    color: '#1E3A8A',
    yc: false,
    events: false,
    website: 'polyverse.com',
    founded: 2015,
  },
  {
    id: 17,
    name: 'Iterable',
    badge: 'Series E',
    stage: 'series-c',
    sector: 'Marketing',
    description: 'Cross-channel marketing platform (Portland office)',
    address: '700 SW 5th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5172,
    lng: -122.6781,
    color: '#7E22CE',
    yc: false,
    events: false,
    website: 'iterable.com',
    founded: 2013,
  },
  {
    id: 18,
    name: 'Globe Sherpa',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Mobility',
    description: 'Mobile ticketing for transit (acquired by moovel)',
    address: '618 NW Glisan St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5256,
    lng: -122.6772,
    color: '#0D9488',
    yc: false,
    events: false,
    website: 'globesherpa.com',
    founded: 2010,
  },
  {
    id: 19,
    name: 'AppFog',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Devtools',
    description: 'Platform-as-a-service for cloud application deployment',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5197,
    lng: -122.6595,
    color: '#F97316',
    yc: false,
    events: false,
    website: 'appfog.com',
    founded: 2010,
  },
  {
    id: 20,
    name: 'Elemental',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'B2B SaaS',
    description: 'Video processing software (acquired by AWS)',
    address: '621 SW Alder St, Portland, OR 97205',
    neighborhood: 'Downtown',
    lat: 45.5198,
    lng: -122.6788,
    color: '#FF9900',
    yc: false,
    events: false,
    website: 'aws.amazon.com/elemental',
    founded: 2006,
  },
  {
    id: 21,
    name: 'Janrain',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Security',
    description: 'Customer identity and access management (acquired by Akamai)',
    address: '519 SW 3rd Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5187,
    lng: -122.6749,
    color: '#005AAA',
    yc: false,
    events: false,
    website: 'janrain.com',
    founded: 2002,
  },
  {
    id: 22,
    name: 'Cedexis',
    badge: 'Acq',
    stage: 'acquired',
    sector: 'Devtools',
    description: 'Real-time internet traffic management (acquired by Citrix)',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5212,
    lng: -122.6594,
    color: '#10B981',
    yc: false,
    events: false,
    website: 'cedexis.com',
    founded: 2009,
  },
  {
    id: 23,
    name: 'Simple',
    badge: 'Closed',
    stage: 'acquired',
    sector: 'Fintech',
    description: 'Online banking and personal finance (acquired by BBVA)',
    address: '1100 SE Grand Ave, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5163,
    lng: -122.6602,
    color: '#00B5E2',
    yc: false,
    events: false,
    website: 'simple.com',
    founded: 2009,
  },
  {
    id: 24,
    name: 'TrackVia',
    badge: 'Series B',
    stage: 'series-b',
    sector: 'B2B SaaS',
    description: 'Low-code application platform for operations',
    address: '1455 NW Irving St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5272,
    lng: -122.6868,
    color: '#0F766E',
    yc: false,
    events: false,
    website: 'trackvia.com',
    founded: 2006,
  },
  {
    id: 25,
    name: 'Hubb',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'B2B SaaS',
    description: 'Event content management platform',
    address: '6900 SW Atlanta St, Portland, OR 97223',
    neighborhood: 'SW Portland',
    lat: 45.4501,
    lng: -122.7619,
    color: '#EC4899',
    yc: false,
    events: true,
    website: 'hubb.me',
    founded: 2014,
  },
  {
    id: 26,
    name: 'Opus Agency',
    badge: 'Growth',
    stage: 'growth',
    sector: 'Marketing',
    description: 'Brand experience and events agency',
    address: '15455 NW Greenbrier Pkwy, Beaverton, OR',
    neighborhood: 'Beaverton',
    lat: 45.5345,
    lng: -122.8553,
    color: '#111827',
    yc: false,
    events: false,
    website: 'opusagency.com',
    founded: 2002,
  },
  {
    id: 27,
    name: 'Thesis',
    badge: 'Growth',
    stage: 'growth',
    sector: 'Marketing',
    description: 'Brand strategy and digital marketing agency',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5223,
    lng: -122.6601,
    color: '#F59E0B',
    yc: false,
    events: true,
    website: 'thesistesting.com',
    founded: 2001,
  },
  {
    id: 28,
    name: 'Vidyard',
    badge: 'Series C',
    stage: 'series-c',
    sector: 'B2B SaaS',
    description: 'Video platform for business (Portland office)',
    address: '1455 NW Overton St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5285,
    lng: -122.6892,
    color: '#EF4444',
    yc: false,
    events: false,
    website: 'vidyard.com',
    founded: 2010,
  },
  {
    id: 29,
    name: 'Outdoorsy',
    badge: 'Series C',
    stage: 'series-c',
    sector: 'Travel',
    description: 'Peer-to-peer RV rental marketplace (Portland office)',
    address: '321 NW Glisan St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5254,
    lng: -122.6760,
    color: '#16A34A',
    yc: false,
    events: false,
    website: 'outdoorsy.com',
    founded: 2014,
  },
  {
    id: 30,
    name: 'Squishable',
    badge: 'Seed',
    stage: 'seed',
    sector: 'Commerce',
    description: 'Designer plush toys and collectibles',
    address: '2701 NW Vaughn St, Portland, OR 97210',
    neighborhood: 'NW Industrial',
    lat: 45.5378,
    lng: -122.7045,
    color: '#F472B6',
    yc: false,
    events: false,
    website: 'squishable.com',
    founded: 2007,
  },
  {
    id: 31,
    name: 'Aclima',
    badge: 'Series B',
    stage: 'series-b',
    sector: 'Climate',
    description: 'Hyperlocal air quality measurement and analytics',
    address: '929 SW 6th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5163,
    lng: -122.6791,
    color: '#65A30D',
    yc: false,
    events: true,
    website: 'aclima.io',
    founded: 2008,
  },
  {
    id: 32,
    name: 'NuScale Power',
    badge: 'Public',
    stage: 'public',
    sector: 'Climate',
    description: 'Small modular nuclear reactor technology',
    address: '6650 SW Redwood Ln, Portland, OR 97224',
    neighborhood: 'SW Portland',
    lat: 45.4286,
    lng: -122.7728,
    color: '#0891B2',
    yc: false,
    events: false,
    website: 'nuscalepower.com',
    founded: 2007,
  },
  {
    id: 33,
    name: 'Sila',
    badge: 'Series B',
    stage: 'series-b',
    sector: 'Fintech',
    description: 'Payments and banking infrastructure API',
    address: '1455 NW Irving St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5275,
    lng: -122.6878,
    color: '#9333EA',
    yc: false,
    events: false,
    website: 'silamoney.com',
    founded: 2018,
  },
  {
    id: 34,
    name: 'Healthify',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'Healthtech',
    description: 'Social care coordination platform',
    address: '811 SW 6th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5171,
    lng: -122.6792,
    color: '#14B8A6',
    yc: false,
    events: false,
    website: 'healthify.us',
    founded: 2013,
  },
  {
    id: 35,
    name: 'Aircover',
    badge: 'Seed',
    stage: 'seed',
    sector: 'AI',
    description: 'AI-powered sales coaching during live calls',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5215,
    lng: -122.6605,
    color: '#8B5CF6',
    yc: false,
    events: false,
    website: 'aircover.ai',
    founded: 2020,
  },
  {
    id: 36,
    name: 'Notable',
    badge: 'Y W21',
    stage: 'series-a',
    sector: 'AI',
    description: 'AI assistant for healthcare workflows',
    address: '519 SW 3rd Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5189,
    lng: -122.6745,
    color: '#0F172A',
    yc: true,
    events: false,
    website: 'notablehealth.com',
    founded: 2017,
  },
  {
    id: 37,
    name: 'Roadtrip',
    badge: 'Y S22',
    stage: 'seed',
    sector: 'Travel',
    description: 'Trip planning and adventure marketplace',
    address: '1455 NW Quimby St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5295,
    lng: -122.6885,
    color: '#F97316',
    yc: true,
    events: true,
    website: 'roadtrip.com',
    founded: 2021,
  },
  {
    id: 38,
    name: 'GreenCart',
    badge: 'Y W23',
    stage: 'seed',
    sector: 'Climate',
    description: 'Carbon-aware grocery delivery service',
    address: '525 SE 6th Ave, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5180,
    lng: -122.6591,
    color: '#22C55E',
    yc: true,
    events: false,
    website: 'greencart.io',
    founded: 2022,
  },
  {
    id: 39,
    name: 'Foundry',
    badge: 'Y S23',
    stage: 'pre-seed',
    sector: 'Devtools',
    description: 'Open source developer infrastructure tools',
    address: '321 SW 4th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5193,
    lng: -122.6762,
    color: '#475569',
    yc: true,
    events: true,
    website: 'foundry.dev',
    founded: 2023,
  },
  {
    id: 40,
    name: 'Cascade',
    badge: 'Y W24',
    stage: 'pre-seed',
    sector: 'AI',
    description: 'AI agents for autonomous data engineering',
    address: '410 SW 5th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5181,
    lng: -122.6779,
    color: '#4338CA',
    yc: true,
    events: false,
    website: 'cascade.ai',
    founded: 2024,
  },
  {
    id: 41,
    name: 'Beeline',
    badge: 'Seed',
    stage: 'seed',
    sector: 'Fintech',
    description: 'Digital mortgage lender for modern borrowers',
    address: '1455 NW Irving St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5268,
    lng: -122.6862,
    color: '#EAB308',
    yc: false,
    events: false,
    website: 'makeabeeline.com',
    founded: 2019,
  },
  {
    id: 42,
    name: 'PortlandLabs',
    badge: 'Bootstrapped',
    stage: 'seed',
    sector: 'Devtools',
    description: 'Open source CMS and web platform development',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5219,
    lng: -122.6608,
    color: '#1D4ED8',
    yc: false,
    events: false,
    website: 'portlandlabs.com',
    founded: 2009,
  },
  {
    id: 43,
    name: 'Possible Finance',
    badge: 'Series B',
    stage: 'series-b',
    sector: 'Fintech',
    description: 'Mobile lending for underbanked consumers',
    address: '506 SW Mill St, Portland, OR 97201',
    neighborhood: 'Goose Hollow',
    lat: 45.5172,
    lng: -122.6878,
    color: '#06B6D4',
    yc: false,
    events: true,
    website: 'possiblefinance.com',
    founded: 2017,
  },
  {
    id: 44,
    name: 'Showpad',
    badge: 'Series D',
    stage: 'series-c',
    sector: 'B2B SaaS',
    description: 'Sales enablement platform (Portland office)',
    address: '929 SW Washington St, Portland, OR 97205',
    neighborhood: 'Downtown',
    lat: 45.5210,
    lng: -122.6810,
    color: '#EF4444',
    yc: false,
    events: false,
    website: 'showpad.com',
    founded: 2011,
  },
  {
    id: 45,
    name: 'Pensar',
    badge: 'Pre-seed',
    stage: 'pre-seed',
    sector: 'AI',
    description: 'AI-powered product design automation',
    address: '811 NW Davis St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5260,
    lng: -122.6810,
    color: '#A855F7',
    yc: false,
    events: true,
    website: 'pensar.ai',
    founded: 2024,
  },
  {
    id: 46,
    name: 'Rumble',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'Security',
    description: 'Network discovery and asset inventory',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5210,
    lng: -122.6603,
    color: '#DC2626',
    yc: false,
    events: false,
    website: 'rumble.run',
    founded: 2018,
  },
  {
    id: 47,
    name: 'Maplebear',
    badge: 'IPO',
    stage: 'public',
    sector: 'Commerce',
    description: 'Grocery delivery and pickup (Portland operations)',
    address: '700 SW 5th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5169,
    lng: -122.6778,
    color: '#16A34A',
    yc: false,
    events: false,
    website: 'instacart.com',
    founded: 2012,
  },
  {
    id: 48,
    name: 'Stratos',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'Climate',
    description: 'Sustainable supply chain and ESG analytics',
    address: '1455 NW Irving St, Portland, OR 97209',
    neighborhood: 'Pearl District',
    lat: 45.5278,
    lng: -122.6896,
    color: '#0D9488',
    yc: false,
    events: false,
    website: 'stratos.io',
    founded: 2020,
  },
  {
    id: 49,
    name: 'Pacific Cloud',
    badge: 'Seed',
    stage: 'seed',
    sector: 'Devtools',
    description: 'Multi-cloud cost optimization and governance',
    address: '510 SW 3rd Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5184,
    lng: -122.6743,
    color: '#0EA5E9',
    yc: false,
    events: false,
    website: 'pacificcloud.io',
    founded: 2022,
  },
  {
    id: 50,
    name: 'Mossroom',
    badge: 'Pre-seed',
    stage: 'pre-seed',
    sector: 'AI',
    description: 'AI-native writing collaboration for teams',
    address: '321 SW 6th Ave, Portland, OR 97204',
    neighborhood: 'Downtown',
    lat: 45.5174,
    lng: -122.6790,
    color: '#15803D',
    yc: false,
    events: true,
    website: 'mossroom.com',
    founded: 2024,
  },
  {
    id: 51,
    name: 'Hammerhead',
    badge: 'Series A',
    stage: 'series-a',
    sector: 'Mobility',
    description: 'Smart cycling navigation and computer hardware',
    address: '2701 NW Vaughn St, Portland, OR 97210',
    neighborhood: 'NW Industrial',
    lat: 45.5372,
    lng: -122.7032,
    color: '#0F172A',
    yc: false,
    events: false,
    website: 'hammerhead.io',
    founded: 2013,
  },
  {
    id: 52,
    name: 'Bridgetown',
    badge: 'Bootstrapped',
    stage: 'seed',
    sector: 'Devtools',
    description: 'Modern static site generator for Ruby',
    address: '107 SE Washington St, Portland, OR 97214',
    neighborhood: 'Central Eastside',
    lat: 45.5208,
    lng: -122.6600,
    color: '#B91C1C',
    yc: false,
    events: false,
    website: 'bridgetownrb.com',
    founded: 2020,
  },
];
